export default {
      id: "icon-bed-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.svg#icon-bed",
      toString: function () {
        return this.url;
      }
    }